import React, { useState } from "react";
import { Tooltip, Icon } from "antd";
import { SectionContent } from "../../../../../../CommonComponents/commonStyles";
import { getPrimaryAccount } from "../../../../../../utils/sessionUtil";
import ErrorPopup from "../../../../../../CommonComponents/ErrorPopup/ErrorPopup";
import { UnderLinkButton, GrantActionItems, RegrantLoader } from "./style";
import { initiateTracking,isAllShareAllPool } from "../../../../../../utils/commonUtil";

function CheckRegrantOptions(props) {
  const [errorFetchingGrantDetails, setErrorFetchingGrantDetails] = useState(
    false
  );
  const [fetchingGrantId, setFetchingGrantId] = useState(null);
  const [showSpawnRegrantWarning, setShowSpawnRegrantWarning] = useState(false);

  const { amount, availableBalance, txnId, isRecurring, charityName, setRegrant, history, fetchGrantData, isMobile } = props;

  const regrantFlow = txnId => {
    const grantId = txnId || fetchingGrantId;
    /*
          Had to use this since the hook updates the value only after render. 
          Not working in case of regrant of a single grant. Will have to revisit
          */
    fetchGrantData({
      userId: getPrimaryAccount().userId,
      grantId: grantId,
      successFn: () => {
        setRegrant();
        initiateTracking('addGrant', 'Grant Activity', `${charityName}`, 'Regrant');
        history.push("/grants/recommend/review");
      },
      failureFn: () => {
        setErrorFetchingGrantDetails(true);
      }
    });
  };
  let isAllShareAllPoolStatus = isAllShareAllPool();
  if (amount < 500) {
    return (
      <Tooltip title="Regrant is unavailable for grant amount less than $500.00.">
        {isMobile ? (<UnderLinkButton disable wid30>Regrant </UnderLinkButton>) : (<GrantActionItems disable wid30>Regrant </GrantActionItems>)}
      </Tooltip>
    );
  } else if (availableBalance < 1) {
    return (
      <Tooltip title="You do not have sufficient balance in your account for regrant.">
        {isMobile ? (<UnderLinkButton disable wid30>Regrant </UnderLinkButton>) : (<GrantActionItems disable wid30>Regrant </GrantActionItems>)}
      </Tooltip>
    );
  }else if (isAllShareAllPoolStatus) {
    return (
      <Tooltip title="A grant has been recommended to close the account. Additional grant transactions cannot be submitted.">
        {isMobile ? (<UnderLinkButton disable wid30>Regrant </UnderLinkButton>) : (<GrantActionItems disable wid30>Regrant </GrantActionItems>)}
      </Tooltip>
    );
  } else {
    return fetchingGrantId === txnId ? (
      <RegrantLoader>
        <Icon type="loading" />
      </RegrantLoader>
    ) : (
        <>
          {isMobile ? (
            <UnderLinkButton
              wid30
              onClick={() => {
                if (isRecurring) {
                  setShowSpawnRegrantWarning(true);
                  return;
                }
                setFetchingGrantId(txnId);
                regrantFlow(txnId);
              }}
            >
              Regrant
            </UnderLinkButton>
          ) :
            (<GrantActionItems
              wid30
              onClick={() => {
                if (isRecurring) {
                  setShowSpawnRegrantWarning(true);
                  return;
                }
                setFetchingGrantId(txnId);
                regrantFlow(txnId);
              }}
            >
              Regrant
        </GrantActionItems>
            )
          }

        <ErrorPopup
          title="Regranting Spawn"
          data-test = "ErrorPopup"
          show={errorFetchingGrantDetails}
          primaryCta={() => {
            setFetchingGrantId(null);
            setErrorFetchingGrantDetails(false);
          }}
          secondaryCta={() => {
            setFetchingGrantId(null);
            setErrorFetchingGrantDetails(false);
          }}
        >
          <SectionContent>
            We could not fetch the grant details for Transaction ID:{" "}
            {fetchingGrantId}. Please try again in sometime.
          </SectionContent>
        </ErrorPopup>

        <ErrorPopup
          data-test = "RegrantingSpawn"
          title="Regranting Spawn"
          show={showSpawnRegrantWarning}
          primaryCta={() => {
            setFetchingGrantId(txnId);
            setShowSpawnRegrantWarning(false);
            regrantFlow(txnId);
          }}
          secondaryCta={() => {
            setFetchingGrantId(null);
            setShowSpawnRegrantWarning(false);
          }}
        >
          <SectionContent>
            Regranting a spawn of a recurring schedule grant will result in a
            recommendation of a one-time grant, not the entire schedule.
          </SectionContent>
        </ErrorPopup>
      </>
    );
  }
}

export default CheckRegrantOptions;
